<template>
    <div>
      <div class="intro-header">
          <div class="about-container">
              <h1>Página no encontrada</h1>
          </div> 
      </div>
      <div class="container">
        <p>
          Lo sentimos, la página que está buscando podría haberse movido o eliminado. Por favor regrese a la <a href="/">página de inicio.</a>
        </p>
      </div>
    </div>
</template>

<script>
export default {};
</script>